<script lang="ts">
  import { onMount } from 'svelte';
  import { surveyStore } from '../stores/surveyStore';
  import { metaPixelService } from '../services/MetaPixelService';
  import { browser } from '$app/environment';

  let pixelId: string | null = null;
  let testMode = false;
  let scriptInjected = false;

  onMount(() => {
    if (!browser) return;

    const unsubscribe = surveyStore.subscribe(state => {
      if (state?.survey?.config?.metaPixel) {
        const config = state.survey.config.metaPixel;

        if (config.enabled && config.pixelId && !scriptInjected) {
          pixelId = config.pixelId;
          testMode = config.options?.testMode || false;

          // Initialize the service
          metaPixelService.initialize(state.survey.config);

          // Inject the pixel script
          injectPixelScript();
          scriptInjected = true;
        }
      }
    });

    return unsubscribe;
  });

  function injectPixelScript() {
    if (!browser || !pixelId) return;

    // Create the pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}'${testMode ? `, {test_event_code: '${import.meta.env.VITE_META_TEST_EVENT_CODE || 'TEST_EVENT'}'}` : ''});
      fbq('track', 'PageView');
    `;

    // Append to head
    document.head.appendChild(script);

    // Create noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    img.alt = '';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }
</script>

<!-- No visible markup needed - script injection happens in onMount -->
